export default __webpack_public_path__ + "assets/images/5a41f46a5020bc8f41ff554d0d890ad3.png";